import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo DocumentCase - 取消上傳中的案件
 */
const CancelUploading = [
    'POST',
    RouteUrlList.API_CancelUploading.path,
    {},
    200,
    {
        status: true,
        code: 0,
        exception: null,
        message: '已成功取消上傳中的案件，所有已上傳的檔案已被刪除'
    }
];

export default CancelUploading;
